import React from "react";

const Cancel = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M100 10.071L89.929 0 50 39.929 10.071 0 0 10.071 39.929 50 0 89.929 10.071 100 50 60.071 89.929 100 100 89.929 60.071 50z" />
  </svg>
);

export default Cancel;
